import { Button, Col, Row } from "react-bootstrap"
import Header from "../Header"
import { CardContent, CardMedia, Divider } from "@mui/material"
import { url_images } from "../../lib/backend/data"
import Card from '@mui/material/Card';
import NewletterSite from "../Home/newsletter";
import SocialIcons from "../Home/socialMedia";
import FooterText from "../Home/footerText";
import { estilo_last_mile } from "../../lib/global/styles";
import { Link } from "react-router-dom";

const Origin = () => {

    const items = [
        {
            title: "Apto para celiacos",
            description: "Hacemos barras de chocolate aptas para todos.",
            icon: "iconosd-03.png"
        },
        {
            title: "Sin azúcar",
            description: "Nuestros productos son saludables y aptos para diabéticos.",
            icon: "iconosd-04.png"
        },
        {
            title: "Sin Lactosa",
            description: "Varios de nuestros productos son sin lactosa.",
            icon: "iconosd-05.png"
        },
        {
            title: "Vegano",
            description: "Contamos con productos aptos para veganos.",
            icon: "iconosd-06.png"
        },
        {
            title: "Keto",
            description: "Todos nuestros productos son bajos en carbohidratos, pero altos en sabor.",
            icon: "iconosd-08.png"
        },
    ]
    const footer = () => {
        const newsletter = <NewletterSite />
        const social = <SocialIcons zone="social_media_footer" />
        const footer_text = <FooterText />
        if (!newsletter && !social && !footer_text) return false

        return <footer>
            <div className='p-4 bg-white'>
                <Row className='justify-content-md-center'>
                    {newsletter ? <Col md={8} xs={12}>{newsletter}</Col> : false}
                    {social ? <Col md={3} xs={12}>{social}</Col> : false}
                </Row>
                {footer_text ? <div className='mt-3'>{footer_text}</div> : false}
            </div>
        </footer>
    }
    return <div>
        <Header />
        <div className="p-4 container">
            <h5 className="mb-0">Sabor Puro – Cacao directo de Piura, Perú</h5>
            <h1 className="bold" style={{ fontSize: 50, color: estilo_last_mile.color_secondary }}>La alternativa saludable</h1>
            <Link to="/"><Button>Ver todos los productos</Button> </Link>

            <hr />

            <Row className="align-items-center">
                <Col md={6} xs={12}>
                    <h4>Somos más que una marca de chocolates; somos el testimonio de que es posible disfrutar de los pequeños placeres de la vida sin sacrificar la salud.</h4>

                    <p style={{ fontWeight: 300 }}>Trabajamos día a día con la misión de llevar a cada rincón de Chile chocolates saludables altamente nutritivos, veganos, libres de gluten, sin azúcar, cetogenicos, con altos porcentajes de cacao, comprometidos con tu salud y el medio ambiente.</p>
                </Col>
                <Col md={6} xs={12}>
                    <Card>
                        <CardMedia
                            component="img"
                            height="350"
                            position="center"
                            image={`${url_images}/chocolateandino/team-chocolate-andino.png`}
                            alt="Equipo Chocolate Andino"
                        />
                        {/* <CardContent>
                        <h4>Visión</h4>
                        <p>Llegar a ser la empresa de chocolate líder en el mercado Chileno, caracterizada por sus productos saludables de excelente calidad y el respeto por la dignidad de sus clientes, proveedores, colaboradores y el medio ambiente.</p>
                    </CardContent> */}
                    </Card>
                </Col>
            </Row>
            <Divider sx={{ mb: 2, mt: 2 }} />
            <Row className="align-items-center">
                <Col md={6} xs={12}>
                    <p style={{ fontWeight: 300 }}>En lo más profundo de Piura, Perú, nace el alma de Andino. Es aquí donde encontramos los más exquisitos granos de cacao, bañados por el sol y acariciados por la brisa del Pacífico, que imparten su esencia única a cada uno de nuestros chocolates. </p>
                    <p style={{ fontWeight: 300 }}>Conscientes de la necesidad de productos en base a ingredientes naturales para quienes apuestan por una vida más saludable, hemos creado una obra maestra: chocolates con solo dos ingredientes, cacao y alulosa. </p>
                    <p style={{ fontWeight: 300 }}>Cada paso de nuestro proceso de producción está impregnado de la pasión por la calidad y la pureza. Desde la selección meticulosa de los granos de cacao hasta la delicada combinación con la alulosa, cada etapa es un tributo a la elegancia y la excelencia, un viaje sensorial que despierta y nutre el cuerpo, dejando una huella de satisfacción y bienestar. </p>
                    <p style={{ fontWeight: 300 }}>En cada trozo de nuestro chocolate, está lo mejor de un viaje desde Piura hasta los hogares de nuestras consumidores en Chile, una historia de sabor refinado y placer sin culpas, donde la calidad y el compromiso con la salud se entrelazan en una experiencia única. </p>
                    {/* <p style={{ fontWeight: 300 }}>Somos más que una marca de chocolates; somos el testimonio de que es posible disfrutar de los pequeños placeres de la vida sin sacrificar la salud.</p> */}
                </Col>
                <Col md={6} xs={12}>
                    <Card>
                        <CardMedia
                            component="img"
                            height="100%"
                            image={`${url_images}/chocolateandino/piura.png`}
                            alt="Equipo Chocolate Andino"
                        />
                    </Card>
                </Col>
            </Row>
            <div className="text-center p-4">
                <p>En cada trozo de nuestro chocolate, está lo mejor de un viaje desde Piura hasta los hogares de nuestras consumidores en Chile, una historia de sabor refinado y placer sin culpas, donde la calidad y el compromiso con la salud se entrelazan en una experiencia única. </p>
            </div>

            <Row className="align-items-center mt-3">
                {items.map((item, index) => <Col className="mb-4" md={4} xs={12} key={index}>
                    {item.icon ? <img src={`${url_images}/chocolateandino/${item.icon}`} alt={item.title} style={{ width: 100, height: 100 }} /> : false}
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                </Col>)}
            </Row>
        </div>
        {footer()}
    </div>
}

export default Origin